import React, { useState } from 'react';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import PortalPage from './pages/Portal/PortalPage';

// Spices Imports
import SpicesHome from './pages/Spices/Home';
import SpicesAbout from './pages/Spices/About';
import SpicesServices from './pages/Spices/Services';
import SpicesContact from './pages/Spices/Contact';

// Apparel Imports
import ApparelHome from './pages/Apparel/Home';
import ApparelAbout from './pages/Apparel/About';
import ApparelServices from './pages/Apparel/Services';
import ApparelContact from './pages/Apparel/Contact';

// Commodity Imports
import CommodityHome from './pages/Commodity/Home';
import CommodityAbout from './pages/Commodity/About';
import CommodityServices from './pages/Commodity/Services';
import CommodityContact from './pages/Commodity/Contact';

const App = () => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [activeView, setActiveView] = useState('Services');

  const handleSelectCompany = (company) => {
    // Debugging: This will show you exactly what ID is being passed in the browser console
    console.log("Navigating to Company ID:", company.id);
    setSelectedCompany(company);
    setActiveView('services');
    window.scrollTo(0, 0);
  };

  const handleBackToPortal = () => {
    setSelectedCompany(null);
    setActiveView('home');
    // Allow time for PortalPage to render before scrolling
    setTimeout(() => {
      const element = document.getElementById('companies');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Render company-specific page components
  const renderCompanyPage = () => {
    if (!selectedCompany) return null;

    // Define Commodity Routes once to avoid repetition
    const commodityRoutes = {
      home: <CommodityHome company={selectedCompany} />,
      about: <CommodityAbout company={selectedCompany} />,
      services: <CommodityServices company={selectedCompany} />,
      contact: <CommodityContact company={selectedCompany} />
    };

    // Mapping of ID string to component sets
    const companyPages = {
      spices: {
        home: <SpicesHome company={selectedCompany} />,
        about: <SpicesAbout company={selectedCompany} />,
        services: <SpicesServices company={selectedCompany} />,
        contact: <SpicesContact company={selectedCompany} />
      },
      apparel: {
        home: <ApparelHome company={selectedCompany} />,
        about: <ApparelAbout company={selectedCompany} />,
        services: <ApparelServices company={selectedCompany} />,
        contact: <ApparelContact company={selectedCompany} />
      },
      // Matches 'Commodities' from your COMPANIES data
      Commodities: commodityRoutes,
      // Matches 'commodities' just in case
      commodities: commodityRoutes,
      // Matches 'global' fallback
      global: commodityRoutes
    };

    // Find the current view (home/about/services/contact) for the selected ID
    const currentPage = companyPages[selectedCompany.id]?.[activeView];

    // Final check: if the page exists, render it. If not, show the error screen.
    return currentPage || (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center text-white flex-col gap-6 p-6">
        <div className="text-center space-y-4">
          <h2 className="text-4xl font-black text-amber-500 uppercase tracking-tighter italic">
            Route Not Configured
          </h2>
          <p className="text-slate-400 text-lg max-w-md mx-auto">
            The system is receiving an ID: <span className="text-white font-mono font-bold px-2 py-1 bg-white/10 rounded">"{selectedCompany.id}"</span> which doesn't match your App logic.
          </p>
        </div>
        <button
          onClick={handleBackToPortal}
          className="px-10 py-4 bg-gradient-to-r from-amber-600 to-amber-700 text-white font-black rounded-2xl hover:scale-105 transition-all shadow-xl shadow-amber-900/20"
        >
          Return to Group Portal
        </button>
      </div>
    );
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#020617]">
      {/* Navbar only shows when a company is selected */}
      {selectedCompany && (
        <Navbar
          company={selectedCompany}
          setView={setActiveView}
          activeView={activeView}
          onBack={handleBackToPortal}
        />
      )}

      <main className="flex-grow">
        {!selectedCompany ? (
          <PortalPage onSelectCompany={handleSelectCompany} />
        ) : (
          renderCompanyPage()
        )}
      </main>

      <Footer />
    </div>
  );
};

export default App;